import { User } from 'api/models';

export const fullName = (
  user: Pick<User, 'firstName' | 'lastName'> | undefined,
): string => [user?.firstName ?? '', user?.lastName ?? ''].join(' ').trim();
